const breakpoints = {
  mobile: '475px',
  tablet: '768px',
  laptop: '1200px',
  desktop: '1600px'
}

type Size = keyof typeof breakpoints

type MediaQuery = (max: Size | '', min?: Size) => string

const mediaQuery: MediaQuery = (max, min) => {
  if (max !== '') {
    if (!min) return `@media (max-width: ${breakpoints[max]})`

    return `@media (min-width: ${breakpoints[min]}) and (max-width: ${breakpoints[max]})`
  }

  return `@media (min-width: ${breakpoints[min as Size]})`
}

export default mediaQuery
